import React, { useState } from 'react';
import { Form, Checkbox, Button, Modal } from 'antd';
import { CloseIcon } from '../../assets/icons';
import { useDispatch } from 'react-redux';
import { updateUserProfile } from '../../services/authApi/userApi';
import { changeAccreditedDetails } from '../../store/reducer/accountSlice';
import { toastNotify } from '../../utils/toastNotify';



const NonAccreditedModal = (props) => {
  const [loading,setLoading] = useState(false)
  const { setIsSelfAttestment, setModalOpen, setModalClose, modalOpen, isSelfAttestment, setSuccessOpen } = props;
  const dispatch = useDispatch();


  const onStepFourSubmit = async (values) => {
    if(Object.values(values).includes(true) || isSelfAttestment){
      setLoading(true);
      const accreditFormData = {
        investorStatus: { ...values },
        selfAttestment: isSelfAttestment,
      };
      try {
        const resp = await updateUserProfile(accreditFormData);
        if (!resp.isError) {
          dispatch(
            changeAccreditedDetails({
              role: Object.values(accreditFormData.investorStatus).includes(true) ? 'Accredited' : 'Investor',
              investorStatus: accreditFormData.investorStatus,
              isRegDInvestor: resp?.data?.user?.isRegDInvestor,
            })
          );
          props.setClose(false);
          setIsSelfAttestment(false)
          setSuccessOpen(true);
        } else {
          toastNotify('error', resp?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      props.setClose(false);
      setModalOpen(true);
    }
  };

  return (
    <Modal
      open={modalOpen}
      onCancel={() => {
        setIsSelfAttestment(false);
        setModalClose(false);
      }}
      closeIcon={<CloseIcon />}
      footer={false}
      width={524}
      centered
    >
      <h4 className='mb-16 text-center'>Non-accredited investor attestation</h4>
      <p className='text-taupe mb-32'>
        As a non-accredited investor federal regulations limit your total investment on Realbricks and other similar platforms to 10% of your annual
        income or net worth - whichever is greater.
      </p>
      <Checkbox checked={isSelfAttestment} onChange={(e) => setIsSelfAttestment(e.target.checked)} id='agreed' className='fz-16 mb-48'>
        I agree to not invest more than 10% of my annual income or net worth - whichever is greater.{' '}
      </Checkbox>
      <Form.Item>
        <Button
        loading={loading}
          onClick={() => {
            onStepFourSubmit({"question1":false,"question2":false,"question3":false,"question4":false,"question5":false});
            setModalOpen(false);
            setSuccessOpen(true)
          }}
          disabled={!isSelfAttestment}
          type='primary'
          htmlType='submit'
          className='w-100'
        >
          Continue
        </Button>
      </Form.Item>
    </Modal>
  );
};

export default NonAccreditedModal;
